import {useSelector} from 'react-redux';


import {userSelectors} from '../../User';


/**
 * @return {object} Current publication of the user
 */
function usePublication() {

    return useSelector(userSelectors.getPublication);
}


export default usePublication;
